import React from 'react';
import { motion } from 'framer-motion';
import { FiCheckCircle } from 'react-icons/fi';
import SectionHead from './SectionHead';
import { process as defaultSteps } from '../data/site';

const ease = [0.22, 1, 0.36, 1];

const Process = ({
  steps = defaultSteps,
  eyebrow = 'How we work',
  title = 'A clear process, from first call to launch',
  subtitle = 'You always know what is happening, what comes next and what you get at every step.',
  alt = true
}) => (
  <section className={`section ${alt ? 'section-alt' : ''}`}>
    <div className="container">
      <SectionHead eyebrow={eyebrow} title={title} subtitle={subtitle} />

      <ol className="timeline" style={{ '--steps': steps.length }}>
        {steps.map((step, index) => (
          <motion.li
            key={step.title}
            className="timeline-step"
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-60px' }}
            transition={{ duration: 0.6, delay: index * 0.12, ease }}
          >
            <div className="timeline-marker">
              <span className="timeline-node">{String(index + 1).padStart(2, '0')}</span>
              {index < steps.length - 1 && (
                <span className="timeline-line" aria-hidden="true">
                  <motion.span
                    className="timeline-line-fill"
                    initial={{ scale: 0 }}
                    whileInView={{ scale: 1 }}
                    viewport={{ once: true, margin: '-60px' }}
                    transition={{ duration: 0.7, delay: 0.3 + index * 0.12, ease }}
                  />
                </span>
              )}
            </div>

            <div className="timeline-card">
              <h3>{step.title}</h3>
              <p>{step.text}</p>
              {step.output && (
                <div className="timeline-output">
                  <FiCheckCircle aria-hidden="true" />
                  <span><small>You get</small>{step.output}</span>
                </div>
              )}
            </div>
          </motion.li>
        ))}
      </ol>
    </div>
  </section>
);

export default Process;
